import React from "react";
import { Link } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { Container, Row, Col, Image } from "react-bootstrap";
import * as Yup from "yup";
import { Formik, Form } from "formik";
import { TextFieldIcon } from "../Common/FormComponents/TextFieldIcon";
import "./forgotpassword.css";
import packageJson from "../../../package.json";

function Index(props) {
  const validate = Yup.object({
    username: Yup.string()
      .required("User id is required")
      .test(
        "is-not-only-whitespace",
        "User id is required",
        (value) => value && value.trim().length > 0,
      ),
  });
  const copyrightYear = new Date().getFullYear();

  return (
    <Formik
      initialValues={{
        username: "",
      }}
      validationSchema={validate}
      onSubmit={(values) => {
        props.forgotPassword(values);
      }}
    >
      {(formik) => (
        <div className="backgroundscreen">
          <div className="backgroundbott">
            <Container>
              <div className="cardMainlogin">
                <Row>
                  <Col xs={12} md={12} sm={12} lg={6} className="login-logo">
                    {/* <div> */}
                    {/* <Image
                        alt="loginimage"
                        className="loginimage"
                        src={require("../../assets/img/Artboard_2.jpg")}
                      /> */}
                    <Image
                      alt="loginimage"
                      className="logo-image"
                      src={require("../../assets/img/NeoLogo.png")}
                    />
                    {/* </div> */}
                  </Col>

                  <Col xs={12} md={12} sm={12} lg={6}>
                    <Container>
                      <div className="loginheaderfrst">
                        {/* <div className="loginLogo">
                          <div>
                            <img
                              alt="logo1"
                              className="logo1"
                              src={require("../../assets/img/logo-sh.png")}
                            />
                          </div>
                          <div className="vl"></div>
                          <div>
                            <img
                              alt="logo2"
                              className="wateronlogo"
                              src={require("../../assets/img/waterOn_logo.png")}
                            />
                          </div>
                        </div> */}
                        <h3 className="forgot-Title">{""}</h3>
                        <h6 className="forgot-msg-cont">
                          Enter the user ID you used to register. We will email
                          you a link to your registered e-mail address with
                          directions to set your new password.
                        </h6>

                        <div className="forgotForm">
                          <Form>
                            <div>
                              <TextFieldIcon
                                placeholder="enter user id"
                                name="username"
                                type="text"
                                label="User Id"
                                // icon="fa fa-at textFieldicon"
                              />
                            </div>

                            <button
                              className="contactpagebtn2"
                              // className={
                              //   formik.values.username
                              //     ? "contactpagebtn2"
                              //     : "contactpagebtn"
                              // }
                              type="submit"
                            >
                              Request reset link
                            </button>
                            <div className="para1div">
                              <p className="para1">
                                <Link to="/login" className="login-back-btn">
                                  Back to Login
                                </Link>
                              </p>
                            </div>
                          </Form>
                        </div>
                      </div>
                    </Container>
                  </Col>
                </Row>
              </div>
              <div className="footerclass">
                <div></div>
                <div className="loginDivVersion">
                  <span>
                    {" "}
                    Version {packageJson.version}© {copyrightYear} SmarterHomes
                    Technologies
                  </span>
                </div>
              </div>
            </Container>
          </div>
        </div>
      )}
    </Formik>
  );
}

export default Index;
